import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'controller/utils/@reduxjs/toolkit';
import {
  useInjectReducer,
  useInjectSaga,
} from 'controller/utils/redux-injectors';
import CustomResponse from 'core/utils/types/CustomResponse';
import { forgotPasswordSaga } from './saga';
import { ForgotPasswordState, UserDetails, VerifyOTPRequest } from './types';

export const initialState: ForgotPasswordState = {
  displayOTP: false,

  OTPDetails: {} as UserDetails,
  isLoadingDetails: false,
  errorGettingDetails: undefined,

  verifyOTP: { isVerified: false },
  isVerifyingOTP: false,
  errorVerifyOTP: undefined,

  resetPassword: {},
  isResetingPassword: false,
  errorResetingPassword: undefined,
};

const slice = createSlice({
  name: 'forgotPassword',
  initialState,
  reducers: {
    verifyUsernameStart(
      state,
      action: PayloadAction<{ data: { USER_NAME: string, SRC: string }; cancelToken: any }>,
    ) {
      state.errorGettingDetails = undefined;
      state.isLoadingDetails = true;
    },
    verifyUsernameSuccess(state, action: PayloadAction<UserDetails>) {
      state.isLoadingDetails = false;
      state.OTPDetails = action.payload;
      state.displayOTP = true;
    },
    verifyUsernameFailure(state, action: PayloadAction<CustomResponse>) {
      state.isLoadingDetails = false;
      state.errorGettingDetails = action.payload;
    },

    verifyOTPStart(
      state,
      action: PayloadAction<{ data: VerifyOTPRequest; cancelToken: any }>,
    ) {
      state.isVerifyingOTP = true;
    },
    verifyOTPSuccess(state, action: PayloadAction<any>) {
      state.isVerifyingOTP = false;
      state.verifyOTP = action.payload;
    },
    verifyOTPFailure(state, action: PayloadAction<CustomResponse>) {
      state.isVerifyingOTP = false;
      state.errorVerifyOTP = action.payload;
    },

    resetPasswordStart(
      state,
      action: PayloadAction<{
        data: { USER_ID: number; NEW_PASSWORD: string };
        token: string;
        cancelToken;
      }>,
    ) {
      state.isResetingPassword = true;
    },
    resetPasswordSuccess(state, action: PayloadAction<{}>) {
      state.isResetingPassword = false;
      state.resetPassword = action.payload;
    },
    resetPasswordFailure(state, action: PayloadAction<CustomResponse>) {
      state.isResetingPassword = false;
      state.errorResetingPassword = action.payload;
    },

    clearState(state) {
      state.OTPDetails = {} as UserDetails;
      state.isLoadingDetails = false;
      state.errorGettingDetails = undefined;
      state.verifyOTP = { isVerified: false };
      state.isVerifyingOTP = false;
      state.errorVerifyOTP = undefined;
      state.displayOTP = false;
    },
  },
});

export const { actions: forgotPasswordActions } = slice;

export const useForgotPasswordSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: forgotPasswordSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useForgotPasswordSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
